<template>
  <header id="header" class="alert headInfo relative">
    <router-link v-if="!isMobile" class="header-title" to="/" exact>
      <span class="header-title-en">ZAHACLUB</span>
      <span class="header-title-ch">嘉禾舞社</span>
    </router-link>

    <div class="header-right">
      <el-dropdown trigger="click" @command="handleCommand">
        <div class="header-user-menu" title="个人中心">
          <v-avatar-nickname :value="user.avatar" :nickname="user.nickname" :avatar-size="36"/>
          <i class="el-icon-arrow-down header-menu-arrow"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="canViewStoreQr" command="store-qr-code">门店二维码</el-dropdown-item>
          <el-dropdown-item command="profile">个人中心</el-dropdown-item>
          <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </header>
</template>

<script>
export default {
  methods: {
    signUp() {
      this.$confirm('确认要退出吗 ? ', '友情提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('user/logout', { is_not_auto_login: 1 });
      }).catch(() => {});
    },
    handleCommand(command) {
      if (command === 'store-qr-code') {
        this.$router.push('/store-qr-codes');
      } else if (command === 'profile') {
        this.$router.push('/administrators/profile');
      } else if (command === 'logout') {
        this.signUp();
      }
    },
    change() {
      this.$confirm('确认要切换账号吗 ? ', '友情提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push('/login');
      }).catch(() => {});
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    canViewStoreQr() {
      return ['administrator', 'manager', 'receptionist', 'receptionist_shift', 'consultant']
        .includes(this.$store.getters.userRole);
    },
  }
}
</script>

<style scoped>
.header-right {
  float: right;
  height: 40px;
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.header-user-menu {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color .2s ease;
}

.header-user-menu:hover {
  background-color: #f0f2f5;
}

.header-menu-arrow {
  font-size: 14px;
  color: #909399;
}
</style>